import { Heading2, Modal } from "@nulogy/components";
import useUpdateWorkOrderDatesModal from "hooks/state/useUpdateWorkOrderDatesModal";
import React from "react";
import PublishWorkOrderDatesFormContainer from "./PublishWorkOrderDatesFormContainer";

const Heading = () => (
  <Heading2 inline mb="none">
    Update work order dates
  </Heading2>
);

export default function PublishWorkOrderDatesModal() {
  const { close, isOpen } = useUpdateWorkOrderDatesModal();

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} onRequestClose={close} title={<Heading />}>
      <PublishWorkOrderDatesFormContainer />
    </Modal>
  );
}
